import { render, staticRenderFns } from "./deviceNew.vue?vue&type=template&id=22f85334&scoped=true&"
import script from "./deviceNew.vue?vue&type=script&lang=js&"
export * from "./deviceNew.vue?vue&type=script&lang=js&"
import style0 from "./deviceNew.vue?vue&type=style&index=0&id=22f85334&scoped=true&lang=css&"
import style1 from "./deviceNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f85334",
  null
  
)

export default component.exports